import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import LinearProgress from '@material-ui/core/LinearProgress';
import Link from '@material-ui/core/Link';

import { t } from 'ttag';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import React from 'react';

const DownloadFileDialog = ({ loading, onAccept, onClose, progress, file }) => (
  <Dialog open={true} onClose={onClose}>
          <DialogTitle>{loading? "Завантаження..." : "Завантажити список спортсменів?"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {loading &&
              <>
                <LinearProgress variant="determinate"  value={progress}/>
                <Typography variant="body2" color="textSecondary">{`${Math.round(progress)}%`}</Typography>
              </>
              }
              {progress === "100" &&
                <Link
                  component="button"
                  variant="body2"
                  onClick={() => {
                    window.open(file, '_blank').focus();
                    onClose();
                  }}
                >
                  Відкрити файл
                </Link>
              }
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              style={{ margin: '20px 0 20px 0' }}
              margin='normal'
              type='button'
              variant='contained'
              color='primary'
              disabled={loading}
              onClick={onAccept}
            >
              {t`Підтвердити`}
            </Button>
            <Button onClick={onClose} color='primary'>
              {t`Відмінити`}
            </Button>
          </DialogActions>

  </Dialog>
);

export default DownloadFileDialog;
